<template>
    <div class="row">
        <div class="col-12">
            <CardRh :processando="processando">
                <div class="p4-agendamento-page">
                    <section class="schedule-hero">
                        <div>
                            <h2>Agendamento de Espaço</h2>
                            <p>Selecione a data para conferir os agendamentos por espaço e cadastrar uma nova reserva.
                            </p>
                        </div> 
                        <div class="date-filter">
                            <label for="dataFiltroAgendamentoEspaco" class="form-label">Data</label>
                            <div class="date-filter-control">
                                <input id="dataFiltroAgendamentoEspaco" v-model="dataFiltro" type="date"
                                    class="form-control form-control-solid" @change="buscarAgendamentos" />
                                <button type="button" class="btn btn-pmes-primary" :disabled="processando"
                                    @click="buscarAgendamentos">
                                    <i class="fa-solid fa-magnifying-glass"></i>
                                </button>
                            </div>
                        </div>
                    </section>

                    <section class="spaces-grid" v-if="espacos && espacos.length">
                        <article class="space-card" v-for="espaco in espacos" :key="espaco.id">
                            <div class="space-card-header">
                                <div> 
                                    <h3>{{ espaco.nome }}</h3> 
                                </div>
                                <button v-if="!dataFiltroMenorQueHoje" type="button" class="btn btn-sm btn-pmes-primary" data-bs-toggle="modal" :data-bs-target="'#' + modal_cadastro" @click="abrirCadastro(espaco)">
                                    Agendar
                                </button>
                            </div>

                            <div class="schedule-list" v-if="agendamentosPorEspaco(espaco.id).length">
                                <div class="schedule-item position-relative" :class="{ 'schedule-item-owner': agendamentoPertenceAoUsuario(agendamento) }" v-for="agendamento in agendamentosVisiveisPorEspaco(espaco.id)" :key="agendamento.id">

                                    <span v-if="descricaoTurmaAgendamento(agendamento)" class="mt-3 turma-badge position-absolute top-0 start-100 translate-middle  badge badge-pmes-warning ">
                                        {{ descricaoTurmaAgendamento(agendamento) }}
                                    </span>

                                    <div class="schedule-time schedule-time-span">
                                        <span class="schedule-time-span">{{ formatarHora(agendamento.horaInicio) }}</span>
                                        <span class="schedule-time-span">às</span>
                                        <span class="schedule-time-span">{{ formatarHora(agendamento.horaFim) }}</span>
                                    </div>
                                    <div class="schedule-info">
                                        <strong>{{ agendamento.nomeInstrucao }}</strong>
                                        
                                    </div>
                                    <div class="schedule-actions">
                                        <!-- <span class="status-badge">{{ formatarStatus(agendamento.status) }}</span> -->
                                        <button type="button" class="btn btn-sm btn-pmes-primary" title="Informacoes"
                                            @click="mostrarDadosAgendamento(agendamento)">
                                            <i class="fa fa-info-circle"></i>
                                        </button>
                                        <button v-if="agendamentoCriadoPeloUsuario(agendamento)" type="button"
                                            class="btn btn-sm btn-pmes-danger" :disabled="processando"
                                            @click="excluirAgendamento(agendamento)">
                                            <i class="fa fa-trash"></i> 
                                        </button>
                                    </div>
                                </div>

                                <button v-if="agendamentosPorEspaco(espaco.id).length > 2" type="button"
                                    class="btn btn-sm btn-light-pmes-primary schedule-view-all"
                                    @click="alternarVisualizacaoAgendamentos(espaco.id)">
                                    {{ agendamentosEspacoExpandido(espaco.id) ? "Ver menos" : "Ver todos" }}
                                </button>
                            </div>

                            <div class="empty-state" v-else>
                                Nenhum agendamento para esta data.
                            </div>
                        </article>
                    </section>

                    <section class="empty-page-state" v-else>
                        Nenhum espaço fisico encontrado para exibicao.
                    </section>
                </div>
            </CardRh>
        </div>
    </div>

    <div class="modal fade" :id="modal_cadastro" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog" style="max-width: 1100px;">
            <div class="modal-content">
                <div class="modal-header">
                    <h2>Novo agendamento</h2>
                    <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <span class="svg-icon svg-icon-1">
                            <inline-svg src="media/icons/duotone/Navigation/Close.svg" />
                        </span>
                    </div>
                </div>

                <div class="modal-body scroll-y m-5">
                    <div class="selected-space">
                        <span>Espaço selecionado</span>
                        <strong>{{ espacoSelecionado?.nome ?? "Selecione um espaço" }}</strong>
                    </div>

                    <div class="row g-5">
                        <div class="col-12 col-md-4">
                            <label for="dataAgendamentoP4" class="form-label">Data</label>
                            <input id="dataAgendamentoP4" v-model="dataAgendamento" type="date" class="form-control" />
                        </div>

                        <div class="col-12 col-md-4">
                            <label for="horaInicioAgendamentoP4" class="form-label">Hora Inicio</label>
                            <input id="horaInicioAgendamentoP4" v-model="horaInicio" type="time" class="form-control" />
                        </div>

                        <div class="col-12 col-md-4">
                            <label for="horaFimAgendamentoP4" class="form-label">Hora Fim</label>
                            <input id="horaFimAgendamentoP4" v-model="horaFim" type="time" class="form-control" />
                        </div>

                        <div class="col-12 col-md-4" v-if="status">
                            <label for="statusAgendamentoP4" class="form-label">Status</label>
                            <Multiselect id="statusAgendamentoP4" v-model="statusId" :options="statusSelect" :searchable="true" disabled />
                        </div>

                        <div class="col-12 col-md-4" v-if="matriculas">
                            <label for="turmasAgendamentoP4" class="form-label">Turma</label>
                            <Multiselect id="turmasAgendamentoP4" v-model="turma" :options="turmasSelect" :searchable="true" />
                        </div>

                        <div class="col-12 col-md-4">
                            <label for="pelotaoAgendamentoP4" class="form-label">Pelotao</label>
                            <input id="pelotaoAgendamentoP4" v-model="pelotao" type="number" class="form-control" :disabled="!!pelotao || pelotao === 0"/>
                        </div>

                        <div class="col-12 col-md-4">
                            <label for="telefoneAgendamentoP4" class="form-label">Telefone Contato</label>
                            <input id="telefoneAgendamentoP4" v-model="telefoneContato" type="text"
                                class="form-control" />
                        </div>

                        <div class="col-12 col-md-8">
                            <label for="instrucaoAgendamentoP4" class="form-label">Nome Instrucao</label>
                            <input id="instrucaoAgendamentoP4" v-model="nomeInstrucao" type="text"
                                class="form-control" />
                        </div>

                        <div class="col-12 col-md-6">
                            <label for="instrutorAgendamentoP4" class="form-label">Nome Instrutor</label>
                            <input id="instrutorAgendamentoP4" v-model="nomeInstrutor" type="text"
                                class="form-control" />
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancelar</button>
                    <button type="button" class="btn btn-pmes-primary" :disabled="processando"
                        @click="salvarAgendamento">Salvar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { namespace } from "vuex-class";
import CardRh from "@/components/cards/ManzaCard.vue";
import Multiselect from "@vueform/multiselect";
import EspacoService from "@/service/v1/sigap/EspacoService";
import AgendamentoEspacoService from "@/service/v1/sigap/AgendamentoEspacoService";
import MatriculaService from "@/service/v10/sigap/MatriculaService";
import SiteUtils from "@/assets/ts/aplicacao/site";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import { User } from "@/store/modules/AuthModule";
import $ from "jquery";
import Swal from "sweetalert2";

const authStore = namespace("auth");

@Options({
    name: "P4AgendamentoEspaco",
    components: { CardRh, Multiselect },
})
export default class P4AgendamentoEspaco extends Vue {
    @authStore.Getter
    public perfis!: any;

    @authStore.Getter
    public currentUser!: User;

    public espacoService = new EspacoService();
    public agendamentoService = new AgendamentoEspacoService();
    public matriculaService = new MatriculaService();
    public processando = false;
    public espacos: any = [];
    public agendamentos: any = [];
    public espacosAgendamentosExpandidos: any = {};
    public matriculas: any = [];
    public matriculaAtual: any = null;
    public status: any = null;
    public dataFiltro = "";
    public modal_cadastro = "modal_p4_agendamento_espaco";

    public espacoSelecionado: any = null;
    public dataAgendamento: any = null;
    public horaInicio: any = null;
    public horaFim: any = null;
    public statusId: any = null;
    public nomeInstrucao: any = null;
    public nomeInstrutor: any = null;
    public pelotao: any = null;
    public turma: any = null;
    public telefoneContato: any = null;

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.P4], this.perfis);
    }

    get dataFiltroMenorQueHoje(): boolean {
        return this.normalizarDataComparacao(this.dataFiltro) < this.getDataAtual();
    }

    get statusSelect() {
        if (this.status) {
            return this.status.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    
    get turmasSelect() {
        if (this.matriculas) {
            return this.matriculas.map((item) => {
                return { value: item.turma, label: item.turma.descricao };
            });
        }
        return [];
    }

    created() {
        this.dataFiltro = this.getDataAtual();
        this.buscarStatus();
        this.buscarEspacos();
        this.getMatriculaAtual();
    }

    public getDataAtual(): string {
        const data = new Date();
        const mes = String(data.getMonth() + 1).padStart(2, "0");
        const dia = String(data.getDate()).padStart(2, "0");
        return `${data.getFullYear()}-${mes}-${dia}`;
    }

    public buscarStatus() {
        this.agendamentoService.getStatus()
            .then(response => {
                this.status = JSON.parse(JSON.stringify(response));
                this.statusId = this.status?.[0]?.id ?? null;
            })
            .catch(() => {
                this.status = null;
            });
    }

    
    public getMatriculaAtual() {
        this.matriculaService.getAll("Skip=0&Take=1&isMatriculaAtual=true")
            .then(response => {
                const matriculas = response.data ?? response;
                this.matriculas = Array.isArray(matriculas) ? JSON.parse(JSON.stringify(matriculas)) : [];
                this.matriculaAtual = this.matriculas[0] ?? null;
                this.turma = this.matriculaAtual?.turma ?? null; 
                this.pelotao = this.matriculaAtual?.pelotao ?? 0; 
            })
            .catch(() => {
                this.matriculas = [];
                this.matriculaAtual = null;
                this.turma = null;
                this.pelotao = 0;
            });
    }

    public buscarEspacos() {
        this.processando = true;
        this.espacoService.getAll("Skip=0&Take=500&status=1")
            .then(response => {
                this.espacos = response.data ?? response;
                this.buscarAgendamentos();
            })
            .catch(error => {
                this.processando = false;
                this.espacos = [];
                SiteUtils.toastErro("Error!", error?.data?.message ?? "Nao foi possivel buscar os espacos.");
            });
    }

    public getParametrosBuscarAgendamentos(): string {
        const parametros = new URLSearchParams();
        const listStatus = [1, 2]; 
        parametros.append("Skip", "0");
        parametros.append("Take", "2000");
        parametros.append("data", this.dataFiltro);

        listStatus.forEach((status) => {
            parametros.append("listStatus", String(status));
        });

        return parametros.toString();
    }

    public buscarAgendamentos() {
        if (!this.dataFiltro) {
            return;
        }

        this.processando = true;
        this.agendamentoService.getAll(this.getParametrosBuscarAgendamentos())
            .then(response => {
                this.agendamentos = response.data ?? response;
                this.espacosAgendamentosExpandidos = {};
                this.processando = false;
            })
            .catch(error => {
                this.processando = false;
                this.agendamentos = [];
                SiteUtils.toastErro("Error!", error?.data?.message ?? "Nao foi possivel buscar os agendamentos.");
            });
    }

    public agendamentosPorEspaco(espacoId) {
        if (!this.agendamentos) {
            return [];
        }

        return this.agendamentos
            .filter((agendamento) => {
                const id = agendamento.espacoLocavel?.id ?? agendamento.espacoLocavelId;
                return Number(id) === Number(espacoId);
            })
            .sort((agendamentoA, agendamentoB) => {
                const horaA = this.formatarHora(agendamentoA?.horaInicio) || "99:99";
                const horaB = this.formatarHora(agendamentoB?.horaInicio) || "99:99";
                return horaA.localeCompare(horaB);
            });
    }

    public agendamentosEspacoExpandido(espacoId) {
        return !!this.espacosAgendamentosExpandidos[espacoId];
    }

    public agendamentosVisiveisPorEspaco(espacoId) {
        const agendamentos = this.agendamentosPorEspaco(espacoId);

        if (this.agendamentosEspacoExpandido(espacoId)) {
            return agendamentos;
        }

        return agendamentos.slice(0, 2);
    }

    public alternarVisualizacaoAgendamentos(espacoId) {
        this.espacosAgendamentosExpandidos = {
            ...this.espacosAgendamentosExpandidos,
            [espacoId]: !this.agendamentosEspacoExpandido(espacoId),
        };
    }

    public abrirCadastro(espaco) {
        this.espacoSelecionado = espaco;
        this.dataAgendamento = this.dataFiltro;
        this.horaInicio = null;
        this.horaFim = null;
        this.statusId = this.status?.[0]?.id ?? this.statusId;
        this.nomeInstrucao = null;
        this.nomeInstrutor = null;
        this.turma = this.matriculaAtual?.turma ?? this.turma;
        this.pelotao = this.matriculaAtual?.pelotao ?? 0;
        this.telefoneContato = null;
    }

    public formatarHora(valor) {
        return valor ? String(valor).substring(0, 5) : "";
    }

    public descricaoTurmaAgendamento(agendamento) {
        const descricaoTurma = agendamento.turma?.descricao
            ? String(agendamento.turma.descricao).substring(0, 35)
            : "";
        return descricaoTurma ? ` ${agendamento.pelotao}º pel - ${descricaoTurma}` : "";
    }

    public formatarStatus(status) {
        return status?.nome ? status.nome.replaceAll("_", " ") : "";
    }

    public mostrarDadosAgendamento(agendamento) {
        Swal.fire({
            title: "Dados do agendamento",
            icon: "info",
            html: this.montarHtmlDadosAgendamento(agendamento),
            width: "1560px",  
            confirmButtonText: "Fechar",
            customClass: {
                content: "swal-agendamento-content",
            },
        });
    }

    public montarHtmlDadosAgendamento(agendamento) {
        const linhas = this.getLinhasDadosAgendamento(agendamento);

        return `
            <div class="swal-agendamento-details">
                ${linhas.map((item) => `
                    <div class="swal-agendamento-row">
                        <span>${item.label}</span>
                        <strong>${item.valor}</strong>
                    </div>
                `).join("")}
            </div>
        `;
    }

    public getLinhasDadosAgendamento(agendamento) {
        const linhas: any[] = [ 
            { label: "Data", valor: SiteUtils.formatData(agendamento?.data ?? this.dataFiltro) },
            { label: "Hora Inicio", valor: this.formatarHora(agendamento?.horaInicio) },
            { label: "Hora Fim", valor: this.formatarHora(agendamento?.horaFim) },
            { label: "Espaco", valor: agendamento?.espacoLocavel?.nome ?? agendamento?.espacoLocavel ?? agendamento?.espacoLocavelId },
            { label: "Turma", valor: this.descricaoTurmaAgendamento(agendamento) },
            { label: "Instrucao", valor: agendamento?.nomeInstrucao },
            { label: "Instrutor", valor: agendamento?.nomeInstrutor },
            { label: "Pelotao", valor: agendamento?.pelotao },
            { label: "Telefone", valor: agendamento?.telefoneContato },
            // { label: "Status", valor: this.formatarStatus(agendamento?.status) },
        ];
 
        return linhas.filter((item) => item.valor !== null && item.valor !== undefined && item.valor !== "");
    }
 
 

    public normalizarDataComparacao(data) {
        if (!data) {
            return "";
        }

        if (data instanceof Date) {
            const mes = String(data.getMonth() + 1).padStart(2, "0");
            const dia = String(data.getDate()).padStart(2, "0");
            return `${data.getFullYear()}-${mes}-${dia}`;
        }

        const dataTexto = String(data);
        if (/^\d{4}-\d{2}-\d{2}/.test(dataTexto)) {
            return dataTexto.substring(0, 10);
        }

        return dataTexto;
    }

    public agendamentoPertenceAoUsuario(agendamento) {
        const usuarioCriador = agendamento.usuarioId ?? agendamento.requisitanteId;
        const usuarioLogado = (this.currentUser as any)?.identificador ?? this.currentUser?.id;

        return usuarioCriador && usuarioLogado && String(usuarioCriador) === String(usuarioLogado);
    }

    public agendamentoCriadoPeloUsuario(agendamento) {
        const dataAgendamento = this.normalizarDataComparacao(agendamento.data ?? this.dataFiltro);
        const dataAtual = this.getDataAtual();

        return this.agendamentoPertenceAoUsuario(agendamento) && dataAgendamento >= dataAtual;
    }

    public excluirAgendamento(agendamento) {
        if (!this.agendamentoCriadoPeloUsuario(agendamento)) {
            return;
        }

        SiteUtils.alertConfimacao("Confirma a exclusao do agendamento?", "",
            () => {
                this.processando = true;
                this.agendamentoService.excluirP4(agendamento.id)
                    .then(() => {
                        SiteUtils.toastSucesso("Agendamento excluido com sucesso!");
                        this.processando = false;
                        this.buscarAgendamentos();
                    })
                    .catch(error => {
                        this.processando = false;
                        SiteUtils.toastErro("Error!", error?.data?.message ?? "Nao foi possivel excluir o agendamento.");
                    });
            }
        );
    }

    public getDadosAgendamento() {
        const dados: any = {};
        dados.data = this.dataAgendamento;
        dados.horaInicio = this.horaInicio;
        dados.horaFim = this.horaFim;
        dados.status = this.statusId;
        dados.espacoLocavelId = this.espacoSelecionado?.id;
        dados.turmaId = this.turma?.id ?? this.turma ?? null;
        dados.nomeInstrucao = this.nomeInstrucao;
        dados.nomeInstrutor = this.nomeInstrutor;
        dados.pelotao = this.pelotao;
        dados.telefoneContato = this.telefoneContato;
        return dados;
    }

    public salvarAgendamento() {
        if (this.processando || !this.hasPermissao) {
            return;
        }

        if (!this.dataAgendamento || !this.horaInicio || !this.horaFim || !this.statusId || !this.espacoSelecionado?.id || !this.nomeInstrucao || !this.nomeInstrutor || (!this.pelotao && this.pelotao !== 0)|| !this.telefoneContato) {
            SiteUtils.toastErro("Error!", "Preencha todos os campos obrigatorios.");
            return;
        }

        this.processando = true;
        this.agendamentoService.cadastrar(this.getDadosAgendamento())
            .then(response => {
                SiteUtils.toastSucesso("Cadastrado com sucesso!", response.message);
                this.processando = false;
                $("[data-bs-dismiss='modal']").trigger({ type: "click" });
                this.buscarAgendamentos();
            })
            .catch(error => {
                this.processando = false;
                SiteUtils.toastErro("Error!", error?.data?.message ?? "Nao foi possivel cadastrar o agendamento.");
            });
    }
}
</script>

<style scoped>
.p4-agendamento-page {
    display: grid;
    gap: 24px;
}

.schedule-hero {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    border: 1px solid #e5edf6;
    border-radius: 22px;
    padding: 15px;
    background: linear-gradient(135deg, #f7fbff 0%, #ffffff 60%, #f7fbff 100%);
}

.hero-kicker,
.space-label {
    display: inline-flex;
    margin-bottom: 8px;
    color: #55708f;
    font-size: 0.78rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.schedule-hero h2,
.space-card h3 {
    margin: 0;
    color: #102542;
    font-weight: 800;
}

.schedule-hero p,
.space-card p {
    margin: 8px 0 0;
    color: #66758a;
}

.date-filter {
    min-width: 320px;
}

.date-filter-control {
    display: flex;
    gap: 10px;
}

.date-filter-control .form-control {
    min-width: 0;
}

.spaces-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    gap: 20px;
}

.space-card {
    display: flex;
    flex-direction: column;
    gap: 18px;
    border: 1px solid #e5edf6;
    border-radius: 22px;
    padding: 20px;
    background: #ffffff;
    box-shadow: 0 10px 26px rgba(16, 37, 66, 0.06);
}

.space-card-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
}

.schedule-list {
    display: grid;
    gap: 12px;
}

.schedule-item {
    display: grid;
    grid-template-columns: 50px 1fr auto;
    gap: 12px;
    align-items: center;
    border-radius: 16px;
    padding: 20px 10px;
    background: #f8fafc;
    border: 1px solid #edf2f7;
}

.schedule-item.schedule-item-owner {   
    /* background: #FDF6E9; */
    border-color: #E3A11E;
    /* box-shadow: inset 4px 0 0 #E3A11E; */
}

.schedule-time {
    display: grid;
    gap: 1px;
    color: #0f5132;
    font-weight: 600;
}

.schedule-time-span {
    max-width: 50px;
}

.schedule-time span {
    display: block;
}

.schedule-info {
    display: grid;
    gap: 2px;
}

.schedule-info strong {
    color: #102542;
}

.schedule-info span,
.schedule-info small {
    color: #66758a;
}

.turma-badge {
    justify-self: start;
    left: 75% !important;
    margin-right: 10px !important;
    border-radius: 999px;
    padding: 3px 8px;
    /* background: #eef6ed;
    color: #2f6f3e !important; */
    font-size: 0.72rem;
    font-weight: 800;
    line-height: 1.2;
}

.schedule-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex-wrap: wrap;
}

.schedule-view-all {
    justify-self: center;
    min-width: 140px;
}

.status-badge {
    border-radius: 999px;
    padding: 6px 10px;
    background: #e8f3ff;
    color: #1d4f8f;
    font-size: 0.78rem;
    font-weight: 800;
    white-space: nowrap;
}

.empty-state,
.empty-page-state {
    border-radius: 16px;
    padding: 18px;
    background: #f8fafc;
    color: #66758a;
    text-align: center;
}

.selected-space {
    display: grid;
    gap: 4px;
    margin-bottom: 20px;
    padding: 16px;
    border-radius: 16px;
    background: #f8fafc;
    border: 1px solid #edf2f7;
}

.selected-space span {
    color: #66758a;
    font-size: 0.82rem;
    font-weight: 700;
    text-transform: uppercase;
}

.selected-space strong {
    color: #102542;
    font-size: 1.05rem;
}

@media screen and (max-width: 991px) {

    .schedule-hero,
    .space-card-header {
        flex-direction: column;
        align-items: stretch;
    }

    .date-filter {
        min-width: 0;
    }

    .date-filter-control {
        flex-direction: column;
    }

    .schedule-item {
        grid-template-columns: 1fr;
    }

    .status-badge {
        justify-self: start;
    }
}

.btn-sm{
    padding: 7px 12px !important;
}



:global(.swal-agendamento-content) {
    margin: 0;
}

:global(.swal-agendamento-details) {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
    max-height: 70vh;
    overflow: auto;
    text-align: left;
}

:global(.swal-agendamento-row) {
    display: grid;
    grid-template-columns: minmax(130px, 0.35fr) 1fr;
    gap: 12px;
    align-items: start;
    padding: 10px 12px;
    border: 1px solid #edf2f7;
    border-radius: 8px;
    background: #f8fafc;
}

:global(.swal-agendamento-row span) {
    color: #66758a;
    font-size: 0.82rem;
    font-weight: 800;
}

:global(.swal-agendamento-row strong) {
    color: #102542;
    font-size: 0.9rem;
    font-weight: 700;
    overflow-wrap: anywhere;
}

@media screen and (max-width: 767px) {
    :global(.swal-agendamento-details) {
        grid-template-columns: 1fr;
    }

    :global(.swal-agendamento-row) {
        grid-template-columns: 1fr;
    }
}



</style>

